// import languageGuards from './language';
import userGuards from "./user.guard";
import type { Router } from "vue-router";
export const initGuards = (router: Router) => {
  userGuards(router);
};
